import { getInitialState } from "../../utils";

const initialState = {
  courseList: [],
  activeCourse: {},
  activeCourseDetails: {},
  courseLanguages: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_COURSE_LIST":
      return setCoursesList(state, action);
    case "SET_ACTIVE_COURSE":
      return setActiveCourse(state, action);
    case "SET_COURSE_DETAILS":
      return setCourseDetails(state, action);
    case "SET_COURSE_LANGUAGES":
      return setCourseLanguages(state, action);
    case "RESET_STATE":
      return resetState(state, action);
    default:
      return state;
  }
}

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setCoursesList = (state, action) => {
  return {
    ...state,
    courseList: action.payload,
  };
};

const setActiveCourse = (state, action) => {
  return {
    ...state,
    activeCourse: action.payload,
  };
};

const setCourseDetails = (state, action) => {
  return {
    ...state,
    activeCourseDetails: action.payload,
  };
};

const setCourseLanguages = (state, action) => {
  return {
    ...state,
    courseLanguages: action.payload,
  };
};
